import { LegacyHistory } from 'ia-react-core/~/interfaces/LegacyHistory';

export function getTabNameFromUrl(param: string) {
  const { searchParams } = new URL(window.location.href);
  return searchParams.get(param);
}

export function setTabNameToUrl(tabName: string, history: LegacyHistory, { querystringParam, selectTabFromUrlMethod }: {querystringParam: string; selectTabFromUrlMethod: 'push' | 'replace'}) {
  const { searchParams } = new URL(document.location.href);
  searchParams.set(querystringParam, tabName);

  history[selectTabFromUrlMethod]({
    ...history.location,
    search: searchParams.toString(),
  });
}
